import React from 'react';
import Typography from '@mui/material/Typography';
import { SizeVariant } from '../../types/variants';
import useStyles from './styles';

const SectionHeader = (props: SectionHeaderPropTypes) => {
  const { classes } = useStyles();
  const { title, size = 'large' } = props;

  const variantMap = {
    small: 'subtitle1',
    medium: 'h6',
    large: 'h5',
  } as const;

  return (
    <div className={classes.container}>
      <Typography variant={variantMap[size]} className={classes.titleText}>
        {title}
      </Typography>
    </div>
  );
};

export type SectionHeaderPropTypes = {
  title: string;
  size?: SizeVariant;
};

export default SectionHeader;
